export default {
  screens: [
    {
      type: 'intro',
      title: '可轉換式珠寶藝術',
      content:
        '「皇室漫步」系列珠寶，向俄羅斯和西伯利亞冬日美景致敬。可轉換式珠寶工藝是匯聚CHAUMET精湛技藝的傑出作品。鑲嵌粉橙色帕帕拉夏 (Padparadscha) 剛玉，線條簡潔、熠熠閃光的項鏈可靈活轉化為胸針。',
      idYt: 'FAAhbyqO57o',
      videoCover: 'world/transformer/video.jpg',
      desktop: {
        cover: 'world/transformer/cover-1.jpg',
        introRight: 'world/transformer/introRight.jpg'
      },
      mobile: {
        cover: 'world/transformer/mobile-cover-1.jpg',
        contentStyle: { width: '92%' },
        coverStyle: {
          width: '34%',
          height: 'auto',
          top: '31.5vh',
          bottom: 'inherit',
          right: '-10px',
          left: 'inherit',
          position: 'absolute'
        },
        introRight: 'world/transformer/introRight.jpg'
      },
      isCover: true
    },
    {
      type: 'memento',
      img: 'world/transformer/memento.jpg',
      imgRight: 'world/transformer/mementoRight.jpg',
      mobile: {
        contentStyle: {
          width: '77.5%',
          left: '22.5%'
        }
      },
      content:
        '這一精湛的工藝同樣表現於「Trésors d’Afrique非域珍藏高級珠寶系列」中：Espiègleries螞蟻胸針可轉換為一對耳環佩戴。'
    },
    {
      type: 'column',
      middleImg: 'world/transformer/columnMiddle.jpg',
      content:
        '來自約瑟芬皇后的後裔-洛伊希騰貝格家族，以美輪美奐的祖母綠打造這頂冠冕。它為CHAUMET珍貴的動感花園帶來無限生機。冠冕上的花葉裝飾會隨佩戴者的動作翩然若動，冠冕上的每朵花飾均可拆卸，作為髮飾或者胸針佩戴。'
    }
  ],
  mobile: {
    mainContentStyle: { paddingBottom: '20px' }
  }
}



// WEBPACK FOOTER //
// ./src/locales/cht/worlds/transformer.js